//react
import React from 'react';

//redux
//import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/Select/Select.jsx";
import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Attachment from "@material-ui/icons/AttachFile";
import Edit from "@material-ui/icons/Edit";


function Transition(props) {
    return <Slide direction="down" {...props} />;
}
  
class AttachmentEditor extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
        modal: false,
        attachment: props.attachment
      };

      if(!this.state.attachment.Audience)
        this.state.attachment.Audience = "";        
    }

    handleClickOpen(modal) {
      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateAttachment(property, value) {
        var obj = this.state.attachment;
        obj[property] = value;
        this.setState({attachment: obj});
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="New Attachment"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit className={ classes.tableActionButtonIcon + " " + classes.edit }  />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            maxWidth="md"
            fullWidth
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">


            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >
              <h4 className={classes.modalTitle}>Edit Attachment</h4>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Attachment,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              labelText="Name"
                              value={this.state.attachment.Name}
                              inputProps={{ placeholder: "Name" }}
                              formControlProps={{ fullWidth: true }}
                              onChange={(e) => this.updateAttachment("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                              <CustomSelect
                                labelText="Audience"
                                value={this.state.attachment.Audience}
                                inputProps={{ placeholder: "Audience" }}
                                formControlProps={{ fullWidth: true }}
                                onChange={(e) => this.updateAttachment("Audience", e.target.value)}
                                options={[
                                  {key:"student",label:"Students"},
                                  {key:"teacher",label:"Teachers"},
                                  {key:"principal",label:"Principals"},
                                  {key:"all",label:"Everyone"}]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                              <CustomSelect
                                labelText="Category"
                                value={this.state.attachment.Category}
                                inputProps={{ placeholder: "Category" }}
                                formControlProps={{ fullWidth: true }}
                                onChange={(e) => this.updateAttachment("Category", e.target.value)}
                                options={[
                                  {key:"sink",label:"Introduce It"},
                                  {key:"cement",label:"Cement It"},
                                  {key:"quick",label:"Quick Cement"},
                                  {key:"revisit",label:"Revisit"},
                                  {key:"k1",label:"K-1"},
                                  {key:"2-3",label:"2-3"},
                                  {key:"4-5",label:"4-5"},
                                  {key:"6-8",label:"6-8"}]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                                labelText="Description"
                                value={this.state.attachment.Description}
                                inputProps={{ placeholder: "Description" }}
                                formControlProps={{ fullWidth: true }}
                                onChange={(e) => this.updateAttachment("Description", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={2}>
                            <CustomInput
                                labelText="Sort Index"
                                value={this.state.attachment.SortIndex}
                                inputProps={{ placeholder: "Sort Index" }}
                                formControlProps={{ fullWidth: true }}
                                onChange={(e) => this.updateAttachment("SortIndex", e.target.value)}
                            />
                          </GridItem>

                        </GridContainer>
                    )
                  },
                  
                ]}
              />
            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                onClick={() => this.handleClose("modal")}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                    this.props.onAttachmentUpdated(this.state.attachment);
                    this.handleClose("modal");
                  }}
                color="success">
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
  const mapStateToProps = state => {
    return state;
  }

  AttachmentEditor = connect(mapStateToProps)(AttachmentEditor);
  export default withStyles(modalStyle)(AttachmentEditor);


// WEBPACK FOOTER //
// ./src/components/AttachmentEditor/AttachmentEditor.jsx